export default __webpack_public_path__ + "static/12-da0a237295e560b6fd2b28d126ccf7ae.webp";